// src/components/modals/AddCustomerModal.jsx
import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';

const AddCustomerModal = ({ isOpen, onClose, onSave }) => {
    const initialState = {
        name: '',
        phone: '',
        email: '',
        address: '',
        birthDate: '' 
    };
    
    const [formState, setFormState] = useState(initialState);

    useEffect(() => {
        if (isOpen) {
            setFormState(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formState.name || !formState.phone || !formState.email || !formState.birthDate) {
        alert('Por favor, preencha todos os campos obrigatórios.');
        return;
    }
    try {
        const customerData = {
            ...formState,
            createdAt: new Date(),
            birthDate: formState.birthDate ? new Date(`${formState.birthDate}T00:00:00`) : null 
        };
        const savedCustomer = await onSave(customerData);
        onClose(savedCustomer); 
    } catch (error) {
        console.error("Erro ao adicionar cliente:", error);
        alert("Ocorreu um erro ao salvar o cliente.");
    }
};

    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-lg m-4 sm:m-8 max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Adicionar Novo Cliente</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="name" className="form-label">Nome Completo</label>
                        <input 
                            id="name" 
                            name="name" 
                            value={formState.name}
                            onChange={handleChange} 
                            type="text" 
                            placeholder="Ex: Maria da Silva" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                            required
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="phone" className="form-label">Telefone</label>
                            <InputMask
                                mask="(99) 99999-9999"
                                value={formState.phone}
                                onChange={handleChange}
                            >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        placeholder="(XX) XXXXX-XXXX"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                        required
                                    />
                                )}
                            </InputMask>
                        </div>
                        <div>
                            <label htmlFor="birthDate" className="form-label">Data de Nascimento</label>
                            <input 
                                id="birthDate" 
                                name="birthDate" 
                                value={formState.birthDate}
                                onChange={handleChange} 
                                type="date" 
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700" 
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="email" className="form-label">Email</label>
                        <input 
                            id="email" 
                            name="email" 
                            value={formState.email}
                            onChange={handleChange} 
                            type="email" 
                            placeholder="exemplo@email.com" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="address" className="form-label">Endereço (Opcional)</label>
                        <input 
                            id="address" 
                            name="address" 
                            value={formState.address}
                            onChange={handleChange} 
                            type="text" 
                            placeholder="Rua, Número, Bairro, Cidade" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                        />
                    </div>
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto"
                        >
                            Cancelar
                        </button>
                        <button 
                            type="submit" 
                            className="custom-button py-2 px-6 font-semibold rounded-lg w-full sm:w-auto"
                        >
                            Salvar Cliente
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCustomerModal;